import { StoreProductsModalState } from './models';

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export const useStoreProductsModalStore = create<StoreProductsModalState>()(
    immer((set) => ({
        isOpen: false,
        storeUuid: '',
        storeName: '',
        excludedProductUuid: null,

        open: ({ storeUuid, storeName, excludedProductUuid }) => {
            set((state) => {
                state.isOpen = true;
                state.storeUuid = storeUuid;
                state.storeName = storeName;
                state.excludedProductUuid = excludedProductUuid ?? null;
            });
        },

        close: () => {
            set((state) => {
                state.isOpen = false;
                state.storeUuid = '';
                state.storeName = '';
                state.excludedProductUuid = null;
            });
        }
    }))
);
